import React, { useState } from 'react';
import ImageLightbox from './ImageLightbox';
import DecorativeElements from './DecorativeElements';
import mainImage from '../assets/WhatsApp Image 2026-04-07 at 10.27.07 AM.jpeg';
import bedroomImage from '../assets/WhatsApp Image 2026-04-07 at 10.27.56 AM.jpeg';
import diningImage from '../assets/WhatsApp Image 2026-04-07 at 10.27.58 AM.jpeg';
import fallbackImage1 from '../assets/hero banner/c6386549c93472abed412dd79c087078.jpg';
import fallbackImage2 from '../assets/hero banner/bd68bdfdb3865c35c4c91a5b0fddcbab.jpg';
import fallbackImage3 from '../assets/hero banner/833dfb1af17258cd8e7e73279ce26b5f.jpg';

const AboutSection = () => {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-8 md:px-16 bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      {/* Decorative Elements */}
      <DecorativeElements />
      
      <div className="relative z-10 max-w-screen-2xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white">
                Crafting Dreams Into Reality
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed">
                With over 15 years of excellence in interior design, we transform spaces into living masterpieces that reflect your unique style and personality.
              </p>
            </div>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center">
                  <span className="material-symbols-outlined text-white text-xl">design_services</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Expert Design Team</h3>
                  <p className="text-gray-300">Our talented designers bring creativity and expertise to every project, ensuring exceptional results.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center">
                  <span className="material-symbols-outlined text-white text-xl">verified</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Quality Assurance</h3>
                  <p className="text-gray-300">We use premium materials and proven techniques to deliver lasting beauty and functionality.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex-shrink-0 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 flex items-center justify-center">
                  <span className="material-symbols-outlined text-white text-xl">schedule</span>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Timely Delivery</h3>
                  <p className="text-gray-300">Projects are completed on schedule with attention to every detail and client satisfaction.</p>
                </div>
              </div>
            </div>
            
            <div className="pt-4">
              <button className="px-8 py-4 rounded-full font-semibold text-white bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 transition-all duration-300 hover:scale-105 shadow-xl">
                Schedule Consultation
              </button>
            </div>
          </div>
          
          {/* Right Content - Image Gallery */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              {/* Main Image */}
              <div className="col-span-2 row-span-2 relative group">
                <div
                  role="button"
                  tabIndex={0}
                  className="relative overflow-hidden rounded-2xl shadow-2xl border border-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
                  onClick={() => setLightbox({ src: mainImage, alt: 'Luxury living room design by Jatin Interior' })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setLightbox({ src: mainImage, alt: 'Luxury living room design by Jatin Interior' });
                    }
                  }}
                >
                  <img 
                    src={mainImage}
                    alt="Luxury living room design by Jatin Interior"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 pointer-events-none"
                    onError={(e) => {
                      e.target.src = fallbackImage1;
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
                </div>
              </div>
              
              {/* Top Right Image */}
              <div className="relative group">
                <div
                  role="button"
                  tabIndex={0}
                  className="relative overflow-hidden rounded-2xl shadow-xl border border-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
                  onClick={() => setLightbox({ src: bedroomImage, alt: 'Modern bedroom interior design' })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setLightbox({ src: bedroomImage, alt: 'Modern bedroom interior design' });
                    }
                  }}
                >
                  <img 
                    src={bedroomImage}
                    alt="Modern bedroom interior design"
                    className="w-full h-48 object-cover transition-transform duration-700 group-hover:scale-105 pointer-events-none"
                    onError={(e) => {
                      e.target.src = fallbackImage2;
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
                </div>
              </div>
              
              {/* Bottom Right Image */}
              <div className="relative group">
                <div
                  role="button"
                  tabIndex={0}
                  className="relative overflow-hidden rounded-2xl shadow-xl border border-gray-800 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900"
                  onClick={() => setLightbox({ src: diningImage, alt: 'Elegant dining room design' })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setLightbox({ src: diningImage, alt: 'Elegant dining room design' });
                    }
                  }}
                >
                  <img 
                    src={diningImage}
                    alt="Elegant dining room design"
                    className="w-full h-48 object-cover transition-transform duration-700 group-hover:scale-105 pointer-events-none"
                    onError={(e) => {
                      e.target.src = fallbackImage3;
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
                </div>
              </div>
            </div>
            
            {/* Floating Stats */}
            <div className="absolute -bottom-8 -left-8 bg-gradient-to-br from-amber-600 to-amber-700 rounded-2xl p-6 shadow-2xl border border-amber-800">
              <div className="text-center">
                <div className="text-3xl font-bold text-white mb-1">500+</div>
                <div className="text-sm text-amber-100">Projects Completed</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ImageLightbox
        isOpen={!!lightbox}
        src={lightbox?.src ?? null}
        alt={lightbox?.alt ?? ''}
        onClose={() => setLightbox(null)}
      />
    </section>
  );
};

export default AboutSection;
